module.exports = __webpack_public_path__ + "files/360d8ef46307b20ef03ca4b0b55dde04.svg";